module.exports = __webpack_public_path__ + "img/service.54b42107.svg";